module.exports = __webpack_public_path__ + "sm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sm.svg
// module id = 810
// module chunks = 0